import styled from '@emotion/styled';
import React, { useCallback, useMemo } from 'react';
import { MoreMenu } from 'ui-components/common/MoreMenu';
import { FancyShareAction, FancyShareActionText } from 'constants/fancyShare';
import { FancySharePublicDto } from '@diritto/common/fancyShare/dtos/fancy-share.dtos';
import { FancyShareDispatchParams } from 'state-hooks/fancyShare/useFancyShareDispatch';
import { showAlertModal } from 'utils/modal';
import { ProfilePublicRelayDto } from '@diritto/common/relay/dtos/profile-relay.dtos';
import { ContentPublicRelayDto } from '@diritto/common/relay/dtos/content-relay.dtos';

interface FancyShareMoreMenuProps {
  fancyShare: FancySharePublicDto;
  content?: ContentPublicRelayDto;
  authorProfile?: ProfilePublicRelayDto;
  actions: FancyShareAction[];
  onDispatchAction: (params: FancyShareDispatchParams) => void;
}

export const FancyShareMoreMenu = ({
  onDispatchAction,
  fancyShare,
  content,
  authorProfile,
  actions,
}: FancyShareMoreMenuProps) => {
  const handleAction = useCallback(
    async (action: FancyShareAction) => {
      switch (action) {
        case FancyShareAction.Share:
          onDispatchAction?.({ action, fancyShare, content, authorProfile });
          return;
        case FancyShareAction.DownloadImage:
          onDispatchAction?.({ action, fancyShare });
          return;
        case FancyShareAction.ActiveEdit:
          onDispatchAction?.({ action, fancyShare });
          return;
        case FancyShareAction.Delete:
          showAlertModal(
            {
              title: `게시글을 삭제하시겠어요?`,
              description: '',
            },
            {
              onConfirm: () => onDispatchAction?.({ action, fancyShare }),
              confirmText: '삭제',
              cancelText: '취소',
            },
          );
          return;
        default:
          console.log("[FancyShareMoreMenu] Can't find action", action);
      }
    },
    [onDispatchAction, fancyShare, content, authorProfile],
  );

  const menu = useMemo(
    () =>
      actions.map(action => ({
        title: FancyShareActionText[action] || '',
        onClick: () => handleAction(action),
      })),
    [actions, handleAction],
  );

  return <StyledMoreMenu vertical menu={menu} />;
};

const StyledMoreMenu = styled(MoreMenu)`
  margin-left: auto;
`;
